var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"scale"}},[_c('v-progress-circular',{staticClass:"mx-auto",attrs:{"size":50,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }